// api-interactions.js

const API_BASE_URL = 'https://learningface.ai/objects'; 
const API_MY_OBJECTS_URL = `https://learningface.ai/userObjects`; // Endpoint to get just the users objects

export async function fetchObjects() {
    try {
        const response = await fetch(API_BASE_URL);
        if (!response.ok) {
            const message = `Error: ${response.status}`;
            throw new Error(message);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching objects:', error);
        throw error; // Re-throw for the UI to handle
    }
}

export async function fetchMyObjects() {
    console.log(`Fetching user's objects FROM: ${API_MY_OBJECTS_URL}`);
    try {
        const response = await fetch(API_MY_OBJECTS_URL);

        if (!response.ok) {
            const message = `Error: ${response.status}`;
            throw new Error(message);
        }

        // Parse the response JSON once and reuse it
        const data = await response.json();
        console.log('Response data:', data);
        return data;
    } catch (error) {
        console.error('Error fetching objects:', error);
        throw error; // Re-throw for the UI to handle
    }
}

export async function fetchObject(key) {
    try {
        console.log(`Fetching object with key: ${key}`);
        const response = await fetch(`${API_BASE_URL}/${key}.json`);
        if (!response.ok) {
            const message = `Error: ${response.status}`;
            const errorDetails = await response.json();
            throw new Error(errorDetails.error || message);
        }
        return await response.json(); // Assuming API returns the object content as text
    } catch (error) {
        console.error(`Error fetching object "${key}":`, error);
        throw error;
    }
}

export async function createObject(objectData) {
    try {
        const response = await fetch(`${API_BASE_URL}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(objectData),
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to create object');
        }
        return await response.json(); // Or response.text() depending on your API response
    } catch (error) {
        console.error(`Error creating object "${objectData}":`, error);
        throw error;
    }
}

export async function updateObject(key, objectData) {
    try {
        // **IMPORTANT:** You need to implement the PUT endpoint in your server.js
        const response = await fetch(`${API_BASE_URL}/${key}.json`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(objectData),
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to update object');
        }
        return await response.json(); // Or response.text()
    } catch (error) {
        console.error(`Error updating object "${key}":`, error);
        throw error;
    }
}

export async function deleteObject(key) {
    try {
        const response = await fetch(`${API_BASE_URL}/${key}.json`, {
            method: 'DELETE',
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to delete object');
        }
        return await response.json(); // Or response.text()
    } catch (error) {
        console.error(`Error deleting object "${key}":`, error);
        throw error;
    }
}
